import React, { useEffect } from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import { PrimaryButton } from "@common";
import locale from "@bonliva-crm/locale";
import { useNavigation } from "@navigation";

export type Props = {
  id: string;
  label: string;
  initialValue: string;
  onChange: (v: string) => void;
  isLoading: boolean;
};

export function FormNote(props: Props) {
  const nav = useNavigation();

  const [value, setValue] = React.useState(props.initialValue);
  const [dirty, setDirty] = React.useState(false);

  useEffect(() => {
    setValue(props.initialValue);
  }, [props.initialValue]);

  useEffect(() => {
    const dirty = value !== props.initialValue;
    setDirty(dirty);
    nav.lockNavigation(`form_note_${props.id}`, dirty, locale.NoteUnSaveBlockMessage);
  }, [value, props.initialValue]);

  return (
    <TextField
      multiline
      fullWidth
      value={value}
      onChange={(e) => setValue(e.target.value)}
      label={props.label}
      helperText={locale["Press Enter for a new line"]}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <PrimaryButton
              disabled={!dirty || props.isLoading}
              style={{ marginBottom: 8 }}
              onClick={() => props.onChange(value)}
              size="small"
            >
              {locale.Save}
            </PrimaryButton>
          </InputAdornment>
        )
      }}
    />
  );
}
